import { SkeletonProps } from '../interface/interface';

const SkeletonLoader = ({ className }: SkeletonProps) => {
  return <div className={`animate-pulse bg-grey-300 ${className}`}></div>;
};

export default SkeletonLoader;
